module.exports = __webpack_public_path__ + "images/7f524b97d5a44f1436d9b4a163330c21-logo_white.png";